import ApiRequest from '../request'

export default class Resolutions {
  constructor() {
    this.apiRequest = new ApiRequest()
  }
  async getOneResolutionFromExtranet(id) {
    try {
      const res = await this.apiRequest.get(`ext_resolutions/${id}`)
      return res
    } catch (error) {
      return error
    }
  }
  async getOneResolution(id) {
    try {
      const res = await this.apiRequest.get(`resolutions/${id}`)
      return res
    } catch (error) {
      return error
    }
  }
  async createPasserelle(data) {
    try {
      const res = await this.apiRequest.post(
        `resolutions/${data.id}/passerelle`,
        { ...data }
      )
      return res
    } catch (error) {
      return error.response
    }
  }
  async create(data) {
    try {
      const res = await this.apiRequest.post(`resolutions`, { ...data })
      return res
    } catch (error) {
      return error.response
    }
  }
  async update(id, data) {
    try {
      const res = await this.apiRequest.put(`resolutions/${id}`, { ...data })
      return res
    } catch (error) {
      return error.response
    }
  }
  async delete(id) {
    try {
      const res = await this.apiRequest.delete(`resolutions/${id}`)
      return res
    } catch (error) {
      return error.response
    }
  }
}
